import React from 'react';
import { UserChip } from './chips/UserChip';

/**
 * A "Last updated by" column for admin tables whose items have `lastUpdatedBy` (a user doc
 * id): the user as a chip. Sorting by it would sort by id, so it can't be sorted; the
 * export has the id.
 */
export const lastUpdatedByColumn = {
	field: 'lastUpdatedBy',
	headerName: 'Last updated by',
	width: 200,
	sortable: false,
	renderCell: ({ value }) => value && <UserChip id={value} />,
};
